import React from 'react';

function YoutubeIcon({ className = '' }) {
	return (
		<svg
			className={className}
			width='32'
			height='32'
			viewBox='0 0 32 32'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<circle cx='16' cy='16' r='16' fill='#F8F5EF' />
			<g clipPath='url(#clip0)'>
				<path
					d='M25.2044 11.3909C24.9831 10.5684 24.3346 9.92002 23.5123 9.69853C22.0098 9.28735 15.9998 9.28735 15.9998 9.28735C15.9998 9.28735 9.99005 9.28735 8.48756 9.68286C7.68103 9.9042 7.01672 10.5685 6.79538 11.3909C6.40002 12.8932 6.40002 16.0089 6.40002 16.0089C6.40002 16.0089 6.40002 19.1403 6.79538 20.627C7.01687 21.4493 7.6652 22.0978 8.48771 22.3193C10.0059 22.7305 16 22.7305 16 22.7305C16 22.7305 22.0098 22.7305 23.5123 22.335C24.3348 22.1136 24.9831 21.4651 25.2046 20.6428C25.5999 19.1403 25.5999 16.0247 25.5999 16.0247C25.5999 16.0247 25.6158 12.8932 25.2044 11.3909Z'
					fill='#CF004F'
				/>
				<path
					d='M13.6 18.8767L18.5976 15.9983L13.6 13.1199V18.8767Z'
					fill='#F8F5EF'
				/>
			</g>
			<defs>
				<clipPath id='clip0'>
					<rect
						width='19.2'
						height='19.2'
						fill='white'
						transform='translate(6.40002 6.3999)'
					/>
				</clipPath>
			</defs>
		</svg>
	);
}

export default YoutubeIcon;
